import logUtil from 'utils/log'
import updateCurrentSidebarAction from 'modules/sidebar/redux/actions/update-current'
import { SIDEBAR_ID } from 'modules/sidebar/constants'
import logEventConversionUtil from 'modules/conversion/utils/log-event'
import { CONVERSION_EVENT } from 'modules/conversion/constants'

export default function openUnlockTierProductSidebarGiftAction (data) {
  return (dispatch) => {
    logUtil('openUnlockTierProductSidebarGiftAction').debug(`[start] data=${data}`)
    logEventConversionUtil(CONVERSION_EVENT.SELECT_ITEM)
    dispatch(updateCurrentSidebarAction(SIDEBAR_ID.UNLOCK_TIER, data))
  }
}
